import ReviewInfo from 'features/reactivation/screens/ReviewInfo/ReviewInfo';
import React from 'react';

export default function ReviewInfoPage() {
  return <ReviewInfo />;
}
